import { lazy } from 'react';

const CustomersList = lazy(() =>  import('../pages/Customers/List'));
const CustomersDetail = lazy(() =>  import('../pages/Customers/Detail'));

export default [{
    path: "/customers",
    element: CustomersList,
    analytics: { name: ["Clienti"]}
}, {
    path: "/customers/:customerId",
    element: CustomersDetail,
    analytics: { name: ["Clienti", "Dettaglio"]},
}]
